import { gql } from '@apollo/client';

const GET_FILTERS = gql`
    query GetFilters {
        user {
            advancedCourtCaseFilterConfigs {
                id
                title
            }
        }
    }
`;

export default GET_FILTERS;
